module.exports = __webpack_public_path__ + "assets/decorazione_down.675ba1c7.svg";